/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.0
 */

import { isLinkExternal } from '@/main/utils/isLinkExternal';

const appExternalRedirect = (path?: string) => {
    if (!path) return;
    if (isLinkExternal(path)) {
        if (window.location.href === path) return;
        window.location.replace(path);
        return;
    }
    if (window.location.pathname === path) return;
    window.location.replace(`${window.location.origin}${path}`);
};

export default appExternalRedirect;
